import styled from 'styled-components';
import { rgba } from 'polished';
import { globalTheme, combineValues } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { InfoLine } from '../../common/InfoLine';

export const Info = styled(InfoLine)`
  padding: 0 ${globalTheme.spacing.md} ${globalTheme.spacing.sm};
`;

export const MediaContainer = styled.div`
  padding: ${globalTheme.spacing.sm} 0 0 ${globalTheme.spacing.lg};
  /* At least two rows of media */
  min-height: calc(${globalTheme.spacing.md} * 12);
  /* After five rows it adds a scrollbar */
  max-height: calc(${globalTheme.spacing.md} * 29);
  overflow: auto;
  background: ${globalTheme.palette.background};
  display: flex;
  flex-wrap: wrap;
`;

export const EmptyContainer = styled(MediaContainer)`
  padding-left: 0;
  align-items: center;
  justify-content: center;
`;

export const OpenInNewContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: ${globalTheme.palette.contrastHigh};
  display: none;
  border-radius: ${globalTheme.radius.lg};
  background-color: ${combineValues(globalTheme.palette.contrastInvert, (color) => rgba(color, 0.5))};
`;
export const RemoveImgContainer = styled.div`
  position: absolute;
  top: calc(-1 * ${globalTheme.spacing.sm} / 2);
  right: calc(-1 * ${globalTheme.spacing.sm} / 2);
  display: none;
  cursor: pointer;
  height: ${globalTheme.spacing.md};
  width: ${globalTheme.spacing.md};
  z-index: 100;
`;
export const RemoveImg = styled(Icon).attrs({ name: 'close', size: 'sm' })`
  top: 0;
  right: 0;
  background: ${globalTheme.palette.brand.accentCoral};
  color: ${globalTheme.palette.background};
  border-radius: ${globalTheme.radius.round};
  padding: calc(${globalTheme.spacing.xxs} / 2);
  position: absolute;
`;

export const ImgContainer = styled.a`
  height: calc(${globalTheme.spacing.md} * 5 - ${globalTheme.spacing.xxs} / 2);
  width: calc(${globalTheme.spacing.xl} * 3 + ${globalTheme.spacing.xxs});
  margin: 0 calc(${globalTheme.spacing.sm} - ${globalTheme.spacing.xxs} / 2) calc(${globalTheme.spacing.sm} - ${globalTheme.spacing.xxs} / 2) 0;
  background: ${globalTheme.palette.secondary};
  border-radius: ${globalTheme.radius.lg};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  &:hover ${OpenInNewContainer} {
    display: flex;
  }
  &:hover ${RemoveImgContainer} {
    display: block;
  }
`;

export const OtherFileIcon = styled(Icon).attrs({ name: 'file', size: 'lg' })`
  color: ${globalTheme.palette.primary};
`;
